import React from 'react';
import './LoadingScreen.css';

/**
 * Full-screen loading component shown during initial app load
 * Displays a skeleton that matches the app's layout structure
 */
const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      {/* Menu skeleton */}
      <div className="loading-menu">
        <div className="loading-logo">
          <div className="loading-logo-icon"></div>
          <div className="loading-logo-text"></div>
        </div>
        <div className="loading-menu-items">
          <div className="loading-menu-item"></div>
          <div className="loading-menu-item"></div>
          <div className="loading-menu-item"></div>
          <div className="loading-menu-item"></div>
          <div className="loading-menu-item"></div>
        </div>
      </div>

      {/* Main content skeleton */}
      <div className="loading-content">
        {/* Sidebar skeleton */}
        <div className="loading-sidebar">
          <div className="loading-sidebar-header"></div>
          <div className="loading-sidebar-item"></div>
          <div className="loading-sidebar-item"></div>
          <div className="loading-sidebar-item"></div>
        </div>

        {/* Calendar skeleton */}
        <div className="loading-calendar">
          <div className="loading-spinner">
            <div className="spinner"></div>
          </div>
          <p className="loading-text">Loading your calendar...</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
